export default {
  title: 'Programma recensioni Google',
  sections: {
    google_review_settings: 'Impostazioni programma recensioni Google',
  },
  form: {
    reward: {
      label: 'Premio (punti)',
      point_value: '100 punti = {{moneyValue}}',
    },
    has_end_date: {
      label: 'Durata',
      options: {
        false: 'Illimitata',
        true: 'Con data di fine specifica',
      },
    },
    end_date: {
      label: 'Data di fine',
    },
  },
  tags: {
    inactive: 'Non attivo',
    active: 'Attivo',
    expired: 'Scaduto',
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dei dati non riuscito',
    changes_got_saved: 'Modifiche salvate',
    failed_to_save_changes: 'Salvataggio delle modifiche non riuscito',
  },
};
